import React from 'react'

import { ReactComponent as FullscreenSVG } from "assets/player/fullscreen.svg";
import { ReactComponent as ExitFullscreenSVG } from "assets/player/exitfullscreen.svg";
import { Button } from '../Button';

const Fullscreen = ({ isFullscreen, onClick }) => (
  <Button onClick={onClick}>
    {isFullscreen
      ? <ExitFullscreenSVG width={22} height={22} />
      : <FullscreenSVG width={22} height={22} />
    }
  </Button>
)

export default Fullscreen